<template>
  <div>
    <v-data-table
      :items="items"
      class="elevation-0"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      disable-sort
      item-class="properties"
      :dense="false"
      :headers="headers"
      :footer-props="footerProps"
      id="pending-users"
    >
      <template v-slot:item.fullname="{ item }">
        <div class="font-weight-bold">{{ item.firstname }} {{ item.lastname }}</div>
      </template>
      <template v-slot:item.email="{ item }">
        <div>{{ item.email }}</div>
      </template>
      <template v-slot:item.institution="{ item }">
        <div>{{ item.institution }}</div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-layout justify-end>
          <v-btn
            rounded
            class="ml-2 font-weight-bold text-capitalize"
            color="black"
            @click="decline(item)"
            outlined
          >
            Decline
          </v-btn>

          <v-btn
            depressed
            rounded
            class="ml-2 white--text font-weight-bold text-capitalize"
            color="primary200"
            @click="accept(item)"
          >
            Accept
          </v-btn>
        </v-layout>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import util from '@/mixins/util.js';

export default {
  name: 'TablePendingRegistration',
  mixins: [util],
  props: {
    urlApi: String,
    search: Object,
    searchAttributes: Array,
  },
  data: () => ({
    firstLoad: true,
    totalItems: 0,
    items: [],
    loading: true,
    options: {},
    itemToBeDeleted: null,
    headers: [
      { text: 'Full Name', value: 'fullname' },
      { text: 'Email', value: 'email' },
      { text: 'Role', value: 'roles', sortable: false },
      { text: 'Institution', value: 'institution' },
      { text: '', value: 'actions' },
    ],
    footerProps: { 'items-per-page-options': [10, 15, 25, 50, 100] },
  }),
  watch: {
    options: {
      handler() {
        console.log('[Table] Options watch');
        if (!this.firstLoad) {
          this.changeOptions();
        }
      },
      deep: true,
    },
  },
  mounted() {
    console.log('[Table] Mounted');
    if (this.firstLoad) {
      /* Populate table from route */
      this.options.page = this.$route.query.index ? Number(this.$route.query.index) + 1 : 1;
      this.options.itemsPerPage = this.$route.query.size ? Number(this.$route.query.size) : 10;
      this.options.sortBy = [];
      this.options.sortDesc = [];
      if (this.$route.query.sort) {
        const sortList = this.$route.query.sort.split(',');
        for (let i = 0; i < sortList.length; i += 1) {
          this.options.sortBy.push(sortList[i].split(' ')[0]);
          if (sortList[i].split(' ')[1] === 'asc') {
            this.options.sortDesc.push(false);
          } else {
            this.options.sortDesc.push(true);
          }
        }
      }
      for (let i = 0; i < this.searchAttributes.length; i += 1) {
        const attr = this.searchAttributes[i];
        if (this.$route.query[attr]) {
          this.$set(this.search, attr, this.$route.query[attr]);
        }
      }
    }
    this.getDataFromApi().then(data => {
      this.items = data.items;
      this.totalItems = data.total;
      this.firstLoad = false;
    });
  },
  methods: {
    triggerSearch() {
      console.log('[Table] Search watch');
      if (!this.firstLoad) {
        this.options.page = 1;
        this.changeOptions();
      }
    },
    changeOptions() {
      this.$router.push({
        path: this.$router.path,
        query: this.getParams(),
      });
      let currentPathName = this.$router.currentRoute.name;
      localStorage[currentPathName] = this.$router.currentRoute.fullPath;
    },
    getDataFromApi() {
      console.log('[Table] Loading data');
      this.loading = true;
      EventBus.$emit('waiting', true);
      return new Promise(resolve => {
        this.axios
          .get(`${this.urlApi}/requested?`, {
            params: this.getParams(),
          })
          .then(res => {
            let items = [];
            let total = 0;
            if (res.status === 200) {
              items = res.data.content;
              total = res.data.total;
            }
            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total,
              });
            });
          })
          .finally(() => {
            EventBus.$emit('waiting', false);
          });
      });
    },
    getParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const query = {
        index: page - 1,
        size: itemsPerPage,
      };
      let sort = '';
      for (let i = 0; i < sortBy.length; i += 1) {
        if (i !== 0) {
          sort += ',';
        }
        let dir = 'asc';
        if (sortDesc[i]) {
          dir = 'desc';
        }
        sort += `${sortBy[i]} ${dir}`;
      }
      if (sort !== '') {
        query.sort = sort;
      }
      for (let i = 0; i < this.searchAttributes.length; i += 1) {
        const attr = this.searchAttributes[i];
        if (this.search[attr]) {
          query[attr] = this.search[attr];
        }
      }
      return query;
    },
    decline(value) {
      EventBus.$emit('waiting', true);
      this.axios
        .put(`${this.urlApi}/disable/${value.id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'User disabled successfully',
          });
          return this.getDataFromApi();
        })
        .then(data => {
          this.items = data.items;
          this.totalItems = data.total;
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
          EventBus.$emit('pending', null);
        });
    },
    accept(value) {
      EventBus.$emit('waiting', true);
      this.axios
        .put(`${this.urlApi}/enable/${value.id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'User enabled successfully',
          });
          return this.getDataFromApi();
        })
        .then(data => {
          this.items = data.items;
          this.totalItems = data.total;
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
          EventBus.$emit('pending', null);
        });
    },
  },
};
</script>

<style scoped>
.v-application--is-ltr .v-data-table__mobile-row__cell {
  text-align: left;
}

tr td {
  min-height: 80px;
  height: 80px !important;
}

tr:hover {
  background: unset !important;
}

tr th {
  color: #1e232c !important;
}
</style>
